import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithTeam } from '~/core/styleTypes';

export const RinkContainer = styled.div`
    display: flex;
    width: 100%;
    aspect-ratio: 1.86 / 1;
    background-color: ${({ theme }) => theme.Surface.secondary};
    position: relative;
`;

export const RinkSvg = styled.svg`
    width: 100%;
`;

export const CenterRedLine = styled.rect`
    fill: ${({ theme }) => theme.Utility.redLine};
    stroke-width: 3px;
    stroke: white;
`;

export const IceSurface = styled.path`
    fill-opacity: 60%;
    stroke: ${({ theme }) => theme.Text.disabled};
    stroke-width: 2;
`;

export const TeamAbbrev = styled.text<WithTeam>`
    ${BaseStyle.Mixins.fontStyles.ui['64m']}
    font-weight: 700;
    fill: ${({ theme, $teamAbbrev }) =>
        $teamAbbrev && theme.Team[$teamAbbrev] ? theme.Team[$teamAbbrev].primary : theme.Text.primary};
`;

export const DasherBoardContent = styled.foreignObject`
    ${BaseStyle.Mixins.fontStyles.ui['64b']};
    text-align: center;
    align-content: center;
    text-transform: uppercase;
`;

export const RinkAdContainer = styled.div<{ $isLeftAligned?: boolean }>`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: ${({ $isLeftAligned }) => ($isLeftAligned ? 'left' : 'right')};

    img {
        width: inherit;
    }
`;
